<template>
  <div>
    <el-dialog
      :visible.sync="show"
      width="70%"
      :close-on-click-modal="false"
      :before-close="closeDialog"
    >

      <el-form
        ref="form"
        :model="submit_data"
        label-width="96px"
      >

        <el-row>
          <el-col :span="12">
            <el-form-item label="账号:">
              <el-input
                v-model="user_name"
                maxlength="20"
                minlength="8"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓名:">
              <el-input
                v-model="submit_data.name"
                maxlength="20"
                minlength="8"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码:">
              <el-input
                v-model="submit_data.password"
                type="password"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="重复密码:">
              <el-input
                v-model="repetition_password"
                type="password"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号:">
              <el-input
                v-model="submit_data.phone"
                maxlength="11"
              ></el-input>
            </el-form-item>
          </el-col>

        </el-row>

        <el-form-item>
          <el-button
            type="primary"
            @click="editAdminSubmit"
          >确定</el-button>
          <el-button @click="closeDialog">取消</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>

  </div>
</template>

<script>
var _this;
import editCompanyDialog from '../company/editCompanyDialog.vue';
export default {
    components: {
        editCompanyDialog
    },

    props: {
        isShow: true,
        data: ''
    },
    //监听父组件传过来的值
    watch: {
        isShow(newData, oldData) {
            _this.show = true;

            _this
                .$post('/pinganadmin/getAdminDetails', {
                    pingan_admin_code: _this.data
                })
                .then((res) => {
                  _this.submit_data.pingan_admin_code = res.data.pingan_admin_code;
                    _this.submit_data.name = res.data.name;
                    _this.submit_data.phone = res.data.phone;
                    _this.user_name = res.data.user_name;
                })
                .catch((err) => {});
        }
    },
    data() {
        return {
            // 重复密码
            repetition_password: '',
            user_name: '',
            // 添加管理员数据
            submit_data: {
                name: '',
                password: '',
                phone: ''
            },
            // 添加管理员数据验证
            submit_rules: {
                password: {
                    placeholder: '密码',
                    rules: {
                        required: true,
                        message: '密码必须为8-20位',
                        regulation: 'between_str',
                        rulesData: [8, 20]
                    }
                },
                name: {
                    placeholder: '名称必须在40字节以内',
                    rules: {
                        required: true,
                        message: '名称必须在40字节以内',
                        regulation: 'elt_str',
                        rulesData: 40
                    }
                },
                phone: {
                    placeholder: '手机号码必须为11位',
                    rules: {
                        required: true,
                        message: '手机号码必须为11位',
                        regulation: 'eq_str',
                        rulesData: 11
                    }
                }
            },
            show: false
        };
    },
    created() {
        _this = this;
    },
    methods: {
        // 关闭方法
        closeDialog() {
            _this.show = false;

            _this.submit_data = {
                name: '',
                password: '',
                phone: ''
            };
        },

        editAdminSubmit() {
            if (_this.submit_data.password == _this.repetition_password) {
                _this
                    .$post('/pinganadmin/editPinganadminSubmit', _this.submit_data, _this.submit_rules)
                    .then((res) => {
                        _this.closeDialog();
                        _this.$message.success('添加' + res.msg);

                        var return_data = {
                            page: 1,
                            limit: 10,
                            name: ''
                        };

                        _this.$emit('onSubmit');
                    })
                    .catch((err) => {});
            } else {
                _this.$message.error('两次输入密码不一致');
            }
        }
    }
};
</script>
<style scoped>
.juese {
    width: 70%;
    margin-top: 5px;
}

.row-list {
    display: flex;

    flex-direction: row;

    align-items: center;

    justify-content: flex-start;

    flex-wrap: wrap;
}

.row-list .el-form-item {
    display: flex;
    flex-direction: row;

    align-items: center;
    justify-content: flex-start;

    width: 50%;
}

.row-list .el-form-item .el-input {
    margin-left: 0;
}

.adminMessage {
    font-family: Microsoft YaHei;
    font-weight: 600;
    line-height: 21px;
    color: #222;
    margin-bottom: 20px;
    font-size: 18px;
}
</style>